import Badge from 'react-bootstrap/Badge'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Stack from 'react-bootstrap/Stack'

import {
  RECOMMENDATION_TYPE_LABELS,
  formatCurrency,
  severityTone,
} from './fnbAnalyticsUtils'

function RecommendationCard({ recommendation }) {
  const tone = severityTone(recommendation.severity)
  const typeLabel =
    RECOMMENDATION_TYPE_LABELS[recommendation.recommendationType] ||
    recommendation.recommendationType

  return (
    <Card
      body
      className={`card--xs card-with-border h-100 fnb-recommendation-card fnb-recommendation-card--${tone}`}
    >
      <Stack gap={2} className="h-100">
        <Stack direction="horizontal" className="flex-wrap gap-2">
          <Badge bg="light" text="dark">
            {typeLabel}
          </Badge>
          <Badge
            bg={
              recommendation.severity === 'high'
                ? 'danger'
                : recommendation.severity === 'medium'
                  ? 'warning'
                  : 'secondary'
            }
          >
            {recommendation.severity || 'info'}
          </Badge>
        </Stack>
        <h3 className="h6 mb-0">{recommendation.title}</h3>
        {recommendation.summary ? (
          <p className="small text-muted mb-0">{recommendation.summary}</p>
        ) : null}
        {recommendation.recommendation ? (
          <p className="small mb-0">{recommendation.recommendation}</p>
        ) : null}
        {recommendation.estimatedImpact != null &&
        recommendation.estimatedImpact > 0 ? (
          <p className="small mb-0 fnb-recommendation-card__impact">
            Est. impact: {formatCurrency(recommendation.estimatedImpact)}
          </p>
        ) : null}
      </Stack>
    </Card>
  )
}

export default function FnbAnalyticsRecommendations({ recommendations }) {
  if (!recommendations?.length) {
    return (
      <p className="text-muted small mb-0">
        No F&amp;B recommendations yet. Recommendations appear once order and
        attendance data is available for this event.
      </p>
    )
  }

  return (
    <Row className="g-3">
      {recommendations.map((recommendation, index) => (
        <Col
          key={`${recommendation.recommendationType}-${index}`}
          md={6}
          xl={4}
        >
          <RecommendationCard recommendation={recommendation} />
        </Col>
      ))}
    </Row>
  )
}
